/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_PermisoRequerido as PermisoRequerido,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_ai as ai,
  rec_borrarSesion as borrarSesion,
  rec_st as st,
} from "../../runtime/index.jsx";
export function SinSecciones() {
  let e = (0, ReactCompiler.c)(2),
    t = st(),
    n;
  return (
    e[0] === t
      ? (n = e[1])
      : ((n = (
          <PermisoRequerido
            icono={ai}
            titulo={`Todavía no tienes secciones habilitadas`}
            mensaje={`Pídele a administración que te habilite la que usas y vuelve a entrar.`}
            acciones={[
              {
                texto: `Cerrar sesión`,
                principal: !0,
                alHacer: () => {
                  (borrarSesion(),
                    t(`/login`, {
                      replace: !0,
                    }));
                },
              },
            ]}
          />
        )),
        (e[0] = t),
        (e[1] = n)),
    n
  );
}
